import Box from '@mui/material/Box'
import { ReactNode } from 'react'
import { colors } from 'styles/theme'

interface Props {
  children: ReactNode
}

const Footer = ({ children }: Props) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{ py: 2, px: 3, borderTop: `1px solid ${colors.gray[100]}` }}
    >
      {children}
    </Box>
  )
}

export default Footer
